<app-side-menu>
  <div class="item-view-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="goBack()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-box me-3"></i>
                Visualizar Item
              </h1>
              <p class="page-subtitle">Detalhes completos do item</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-3">Carregando dados do item...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="loadItem()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Item Details -->
    <div *ngIf="item && !loading" class="row g-4">
      <!-- Informações Básicas -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Código</label>
                  <div class="info-value item-code">{{ item.code }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Nome</label>
                  <div class="info-value item-name">{{ item.name }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Descrição</label>
                  <div class="info-value">{{ item.description || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Estoque</label>
                  <div class="info-value">{{ item.stockName || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Almoxarifado</label>
                  <div class="info-value">{{ item.warehouseName || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Número de Série</label>
                  <div class="info-value">{{ item.serialNumber || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Número do Lote</label>
                  <div class="info-value">{{ item.batchNumber || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Fabricante</label>
                  <div class="info-value">{{ item.manufacturerName || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Modelo</label>
                  <div class="info-value">{{ item.model || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Número da Peça</label>
                  <div class="info-value">{{ item.partNumber || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Propriedades Físicas -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-ruler me-2"></i>
              Propriedades Físicas
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Unidade</label>
                  <div class="info-value">{{ item.unit || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Peso</label>
                  <div class="info-value">{{ formatNumber(item.weight, 3) }} kg</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Volume</label>
                  <div class="info-value">{{ formatNumber(item.volume, 3) }} m³</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Comprimento</label>
                  <div class="info-value">{{ formatNumber(item.length, 1) }} cm</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Largura</label>
                  <div class="info-value">{{ formatNumber(item.width, 1) }} cm</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Altura</label>
                  <div class="info-value">{{ formatNumber(item.height, 1) }} cm</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Cor</label>
                  <div class="info-value">{{ item.color || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Tamanho</label>
                  <div class="info-value">{{ item.size || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Localização -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-map-marker-alt me-2"></i>
              Localização
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Localização Específica</label>
                  <div class="info-value">{{ item.specificLocation || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Prateleira</label>
                  <div class="info-value">{{ item.shelf || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Rack/Estante</label>
                  <div class="info-value">{{ item.rack || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Posição</label>
                  <div class="info-value">{{ item.position || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Controle de Estoque -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-boxes me-2"></i>
              Controle de Estoque
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Quantidade Atual</label>
                  <div class="info-value quantity-value" 
                       [class.low-stock]="item.isLowStock"
                       [class.out-of-stock]="item.quantity === 0">
                    {{ formatNumber(item.quantity) }} {{ item.unit || '' }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Quantidade Mínima</label>
                  <div class="info-value">{{ formatNumber(item.minimumQuantity) }} {{ item.unit || '' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Quantidade Máxima</label>
                  <div class="info-value">{{ formatNumber(item.maximumQuantity) }} {{ item.unit || '' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Status de Qualidade</label>
                  <div class="info-value">{{ item.qualityStatus || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data de Fabricação</label>
                  <div class="info-value">{{ formatDate(item.manufactureDate) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data de Validade</label>
                  <div class="info-value" 
                       [class.expired]="item.isExpired" 
                       [class.near-expiration]="item.isNearExpiration">
                    {{ formatDate(item.expirationDate) }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Consumir Preferencialmente</label>
                  <div class="info-value">{{ formatDate(item.bestBeforeDate) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Dias para Vencimento</label>
                  <div class="info-value" 
                       [class.expired]="item.isExpired" 
                       [class.near-expiration]="item.isNearExpiration">
                    {{ item.daysToExpiration || 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações Financeiras -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-dollar-sign me-2"></i>
              Informações Financeiras
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Custo Unitário</label>
                  <div class="info-value">{{ formatCurrency(item.unitCost, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Custo Total</label>
                  <div class="info-value">{{ formatCurrency(item.totalCost, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Preço Unitário</label>
                  <div class="info-value">{{ formatCurrency(item.unitPrice, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Preço Total</label>
                  <div class="info-value">{{ formatCurrency(item.totalPrice, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Moeda</label>
                  <div class="info-value">{{ item.currencyCode || 'BRL' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Preço de Custo</label>
                  <div class="info-value">{{ formatCurrency(item.costPrice, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Preço de Venda</label>
                  <div class="info-value">{{ formatCurrency(item.salePrice, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Limite de Aprovação</label>
                  <div class="info-value">{{ formatCurrency(item.approvalValueLimit, item.currencyCode) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Requer Aprovação</label>
                  <div class="info-value">
                    <span class="badge" [class]="'badge-' + (item.requiresApproval ? 'warning' : 'secondary')">
                      <i class="fas" [class]="item.requiresApproval ? 'fa-check-circle' : 'fa-times-circle'"></i>
                      {{ item.requiresApproval ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Status e Condição -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-flag me-2"></i>
              Status e Condição
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Status</label>
                  <div class="info-value">
                    <span class="badge" [class]="getStatusClass(item.status)">
                      {{ item.status }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Condição</label>
                  <div class="info-value">
                    <span class="badge" [class]="getConditionClass(item.condition)">
                      {{ item.condition || 'N/A' }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Item Ativo</label>
                  <div class="info-value">
                    <span class="badge" [class]="item.isActive ? 'bg-success' : 'bg-danger'">
                      {{ item.isActive ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Em Uso</label>
                  <div class="info-value">
                    <span class="badge" [class]="item.isInUse ? 'bg-warning' : 'bg-success'">
                      {{ item.isInUse ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Danificado</label>
                  <div class="info-value">
                    <span class="badge" [class]="item.isDamaged ? 'bg-danger' : 'bg-success'">
                      {{ item.isDamaged ? 'Sim' : 'Não' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações Adicionais -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-info me-2"></i>
              Informações Adicionais
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Referência do Fornecedor</label>
                  <div class="info-value">{{ item.supplierReference || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Código de Barras</label>
                  <div class="info-value barcode">{{ item.barcode || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Código QR</label>
                  <div class="info-value qr-code">{{ item.qrCode || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Último Movimento</label>
                  <div class="info-value">{{ formatDate(item.lastMovementDate) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Tipo do Último Movimento</label>
                  <div class="info-value">{{ item.lastMovementType || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Último Inventário</label>
                  <div class="info-value">{{ formatDate(item.lastInventoryDate) }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Observações</label>
                  <div class="info-value notes">{{ item.notes || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações de Auditoria -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-history me-2"></i>
              Informações de Auditoria
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Criado em</label>
                  <div class="info-value">{{ formatDate(item.createdAt) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Criado por</label>
                  <div class="info-value">{{ item.createdBy || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Atualizado em</label>
                  <div class="info-value">{{ formatDate(item.updatedAt) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Atualizado por</label>
                  <div class="info-value">{{ item.updatedBy || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Histórico de Transferências -->
    <div *ngIf="item && !loading" class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-history me-2"></i>
              Histórico de Transferências
            </h5>
          </div>
          <div class="card-body">
            <!-- Loading State -->
            <div *ngIf="loadingHistory" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-3">Carregando histórico...</p>
            </div>

            <!-- Empty State -->
            <div *ngIf="!loadingHistory && transferHistory.length === 0" class="text-center py-4">
              <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
              <p class="text-muted">Nenhuma transferência registrada para este item.</p>
            </div>

            <!-- Transfer History Table -->
            <div *ngIf="!loadingHistory && transferHistory.length > 0" class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Tipo</th>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th>Quantidade</th>
                    <th>Responsável</th>
                    <th>Motivo</th>
                    <th>Observações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let transfer of transferHistory">
                    <td>
                      <span class="badge bg-light text-dark">
                        {{ formatDate(transfer.transferDate) }}
                      </span>
                    </td>
                    <td>
                      <span class="badge" [class]="getTransferTypeClass(transfer.transferType)">
                        {{ getTransferTypeLabel(transfer.transferType) }}
                      </span>
                    </td>
                    <td>
                      <div class="transfer-location">
                        <div class="location-name">{{ transfer.sourceStockName || 'N/A' }}</div>
                        <small class="text-muted">{{ transfer.sourceWarehouseName || '' }}</small>
                      </div>
                    </td>
                    <td>
                      <div class="transfer-location">
                        <div class="location-name">{{ transfer.targetStockName || 'N/A' }}</div>
                        <small class="text-muted">{{ transfer.targetWarehouseName || '' }}</small>
                      </div>
                    </td>
                    <td>
                      <span *ngIf="transfer.quantity" class="quantity-badge">
                        {{ transfer.quantity }}
                      </span>
                      <span *ngIf="!transfer.quantity" class="text-muted">-</span>
                    </td>
                    <td>
                      <span class="staff-name">{{ transfer.staffName || 'N/A' }}</span>
                    </td>
                    <td>
                      <span *ngIf="transfer.reason" class="reason-text">{{ transfer.reason }}</span>
                      <span *ngIf="!transfer.reason" class="text-muted">-</span>
                    </td>
                    <td>
                      <span *ngIf="transfer.notes" class="notes-text" [title]="transfer.notes">
                        {{ transfer.notes.length > 50 ? (transfer.notes | slice:0:50) + '...' : transfer.notes }}
                      </span>
                      <span *ngIf="!transfer.notes" class="text-muted">-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div *ngIf="item && !loading" class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-cogs me-2"></i>
              Ações
            </h5>
          </div>
          <div class="card-body">
            <div class="d-flex gap-2 flex-wrap">
              <button *appHasPermission="'Items.Edit'" class="btn btn-primary" (click)="editItem()">
                <i class="fas fa-edit me-2"></i>
                Editar Item
              </button>
              <button *appHasPermission="'Items.Edit'" class="btn btn-success" (click)="transferItem()" [disabled]="item.status === 'Em Trânsito'">
                <i class="fas fa-exchange-alt me-2"></i>
                Transferir Item
              </button>
              <button *appHasPermission="'Items.Edit'" class="btn btn-outline-danger" (click)="deleteItem()">
                <i class="fas fa-trash me-2"></i>
                Excluir Item
              </button>
              <button class="btn btn-outline-secondary" (click)="goBack()">
                <i class="fas fa-arrow-left me-2"></i>
                Voltar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Transfer Modal -->
  <app-item-transfer-modal
    [item]="item"
    [isVisible]="showTransferModal"
    (close)="closeTransferModal()"
    (success)="onTransferSuccess()">
  </app-item-transfer-modal>
</app-side-menu>